const PUBLIC_CODE_PATTERN = /^[A-Z][A-Z0-9]{1,9}-\d+$/

/** Company survey code such as `DEV-1`. Sign-up slugs do not match. */
export function normalizeSurveyPublicCode(value: string): string | null {
  const code = value.trim().toUpperCase()
  return PUBLIC_CODE_PATTERN.test(code) ? code : null
}
